import {StringFilter} from "./String";
import {IntegerFilter} from "./Integer";
import {BooleanFilter} from "./Boolean";
import {CollectionSelectFilter} from "./CollectionSelect";
import {SelectFilter} from "./Select";
import {DateFilter} from "./Date";
import {DatetimeFilter} from "./Datetime";
import {DecimalFilter} from "./Decimal";
import {JsonObjectFilter} from "./JsonObject";

const filters: {[key: string]: any} = {
    string: StringFilter,
    identifier: StringFilter,
    integer: IntegerFilter,
    decimal: DecimalFilter,
    boolean: BooleanFilter,
    json_object: JsonObjectFilter,
    collection_select: CollectionSelectFilter,
    collection_multiselect: CollectionSelectFilter,
    date: DateFilter,
    select: SelectFilter,
    multiselect: SelectFilter,
    datetime: DatetimeFilter,
    text: StringFilter
}
export default filters;
